import React from "react";
import { OcChartSummaryView } from "./chart-summary-view";
import { useOcChartSummary } from "./use-chart-summary";
import { OcChartProps } from "oc/components/chart/chart";

export interface OcChartSummaryProps {
  summaryTitle: string;
  summaryText: string;
  loading?: boolean;
  variant: OcChartProps["variant"];
}

export const OcChartSummary: React.FC<OcChartSummaryProps> = (props) => {
  const extraProps = useOcChartSummary({
    summaryTitle: props.summaryTitle,
    variant: props.variant,
  });

  return <OcChartSummaryView {...extraProps} {...props} />;
};
